// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"926f0775","455":"8f5303f2","977":"41c9292e"}[chunkId] + ".chunk.js";
};